var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99301 0.333984C3.31301 0.333984 0.333008 3.32065 0.333008 7.00065C0.333008 10.6807 3.31301 13.6673 6.99301 13.6673C10.6797 13.6673 13.6663 10.6807 13.6663 7.00065C13.6663 3.32065 10.6797 0.333984 6.99301 0.333984ZM9.81967 11.0007L6.99967 9.30065L4.17967 11.0007L4.92634 7.79398L2.43967 5.64065L5.71967 5.36065L6.99967 2.33398L8.27967 5.35398L11.5597 5.63398L9.07301 7.78732L9.81967 11.0007Z",
    fill: "#FFB522"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumStar);
export default __webpack_public_path__ + "static/media/premiumStar.ec3e86b34c0102f7abf07ed5dc9f5b26.svg";
export { ForwardRef as ReactComponent };